<template>
  <v-card class="overflow-hidden elevation-4 outlined" id="modal-container" :style="cardStyle">

    <v-card-title class="d-flex align-center px-4 py-3 white--text" :style="{ backgroundColor: headerColor }">

      <v-icon color="white" class="mr-3">{{ icon }}</v-icon>

      <div class="text-subtitle-1 font-weight-bold flex-grow-1 title-text text-wrap mb-0">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      
      <v-btn 
        icon 
        small 
        dark 
        @click="close" 
        title="Cerrar" 
        class="ml-2 shrink btn-close"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="custom-content custom-scroll" :style="contentStyle">
      <slot>
        {{ content }}
      </slot>
    </v-card-text>

    <v-divider v-if="$slots.actions"></v-divider>
    <v-card-actions class="px-4 py-3 bg-light" v-if="$slots.actions">
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    title: {
      type: String,
      default: "Información",
    },
    content: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-information-outline",
    },
    headerColor: {
      type: String,
      default: "#EE680B",
    },
    /** Ancho fijo del modal (ej. "700px"). Sin esto, se ajusta al contenido. */
    width: {
      type: [String, Number],
      default: null,
    },
    /** Alto maximo del contenido scrolleable (ej. "80vh"). Por defecto 65vh. */
    contentMaxHeight: {
      type: [String, Number],
      default: null,
    },
    /**
     * La X no cierra: emite `cerrar` y el contenido decide (p. ej. preguntar
     * si descarta cambios sin guardar, o ignorarla durante un proceso).
     */
    cierreControlado: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardStyle() {
      if (!this.width) return {};
      const width = typeof this.width === 'number' ? `${this.width}px` : this.width;
      // min() evita que el ancho fijo desborde en pantallas angostas (celulares).
      return { width: `min(${width}, calc(100vw - 32px))`, maxWidth: `min(${width}, calc(100vw - 32px))` };
    },
    contentStyle() {
      if (!this.contentMaxHeight) return {};
      const maxHeight = typeof this.contentMaxHeight === 'number' ? `${this.contentMaxHeight}px` : this.contentMaxHeight;
      return { maxHeight };
    },
  },
  methods: {
    close() {
      if (this.cierreControlado) {
        this.$emit('cerrar');
        return;
      }
      this.$store.dispatch('closeTopModal');
    },
  },
};
</script>

<style scoped>

#modal-container {
  border-radius: 24px 0 24px 0 !important; 
}
.bg-light {
  background-color: #fcfcfc;
}

.title-text {
  line-height: 1.25 !important;
  word-break: break-word;
}

.shrink {
  flex-shrink: 0 !important;
}

.btn-close {
  transition: transform 0.2s ease, background-color 0.2s ease;
}
.btn-close:hover {
  transform: scale(1.1);
  background-color: rgba(255, 255, 255, 0.1);
}

.custom-scroll {
  max-height: 65vh;
  overflow-y: auto;

  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #EE680B;
}
</style>